import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import { useAtom } from 'jotai';
import { useMemo } from 'react';

import countries from '@/constants/countries.constants';
import { DATE_FORMAT } from '@/constants/date.constants';
import { ticketAtom } from '@/pages/Ticket';

import useStyles from './TemplateCustomData.styles';

const TemplateCustomDataTravelNotification = () => {
  const [{ custom_data }] = useAtom(ticketAtom);
  const { classes } = useStyles();

  const travelLocations = useMemo(() => {
    return custom_data?.travel_notification?.locations?.map(
      (countryCode: string) => countries[countryCode]
    );
  }, [custom_data?.travel_notification?.locations]);

  return (
    <>
      <Divider sx={{ borderWidth: '1px' }} />
      <Typography variant="h5">Travel Notification:</Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableCellWidth20}>User</TableCell>
              <TableCell className={classes.tableCellWidth10}>
                Start Date
              </TableCell>
              <TableCell className={classes.tableCellWidth10}>
                End Date
              </TableCell>
              <TableCell className={classes.tableCellWidth10}>
                Desired Action
              </TableCell>
              <TableCell>Locations</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                {custom_data?.travel_notification?.user_email}
              </TableCell>
              <TableCell>
                {dayjs(custom_data?.travel_notification?.start_date).format(
                  DATE_FORMAT
                )}
              </TableCell>
              <TableCell>
                {dayjs(custom_data?.travel_notification?.end_date).format(
                  DATE_FORMAT
                )}
              </TableCell>
              <TableCell sx={{ textTransform: 'uppercase' }}>
                {custom_data?.travel_notification?.desired_action}
              </TableCell>
              <TableCell>
                <List>
                  {travelLocations?.map((location) => (
                    <ListItem key={location} sx={{ pl: 0, py: 0.05 }}>
                      <ListItemText primary={location} />
                    </ListItem>
                  ))}
                </List>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TemplateCustomDataTravelNotification;
